import React from "react"
import { Block } from "baseui/block"
import Slider from "react-slick"
import { ChevronLeft, ChevronRight } from "baseui/icon"
import { Button, KIND } from "baseui/button"
import { sliceEvery } from "../utils/arrayUtils"

type HighlightChannelListProps = {
  highlightChannels: any[]
}

const Arrow = ({ direction, onClick }: any) => {
  const style = direction === "right" ? { right: "0px" } : { left: "0px" }

  return (
    <Button
      overrides={{
        BaseButton: {
          style: ({ $theme }) => ({
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "8px",
            paddingRight: "8px",
            position: "absolute",
            top: "50%",
            marginTop: "-25px",
            zIndex: 100,
            backgroundColor: "transparent",
            marginLeft: "-16px",
            marginRight: "-16px",
            [$theme.mediaQuery.medium]: {
              marginLeft: "0px",
              marginRight: "0px",
            },
            ...style,
            ":hover": {
              backgroundColor: "transparent",
            },
          }),
        },
      }}
      kind={KIND.minimal}
      onClick={onClick}
    >
      {direction === "right" ? (
        <ChevronRight
          size={35}
          color={"white"}
          overrides={{ Svg: { style: { cursor: "pointer" } } }}
        />
      ) : (
        <ChevronLeft
          size={35}
          color={"white"}
          overrides={{ Svg: { style: { cursor: "pointer" } } }}
        />
      )}
    </Button>
  )
}

const HighlightChannelList = ({
  highlightChannels,
}: HighlightChannelListProps) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow direction={"right"} />,
    prevArrow: <Arrow direction={"left"} />,
  }

  const [channelsGroup, setChannelsGroup] = React.useState(
    sliceEvery(
      highlightChannels,
      typeof window !== "undefined" && window.innerWidth < 710 ? 9 : 18
    )
  )

  React.useEffect(() => {
    const handleResize = () => {
      setChannelsGroup(
        sliceEvery(
          highlightChannels,
          typeof window !== "undefined" && window.innerWidth < 710 ? 9 : 18
        )
      )
    }

    window.addEventListener("resize", handleResize)
  }, [])

  return (
    <Slider {...settings}>
      {channelsGroup.map((group, index) => (
        <div key={`channels-group-${index}`}>
          <Block
            width={["90%", "90%", "90%", "80%"]}
            margin={"auto"}
            display={"flex"}
            flexWrap={true}
            key={`channel-block-${index}`}
            justifyContent={"center"}
          >
            {group.map(channel => (
              <Block
                key={channel.id}
                width={["33.33%", "16.66%", "16.66%", "16.66%"]}
                display={"inline-block"}
              >
                <Block
                  marginLeft={["4px", "5px", "8px", "8px"]}
                  marginRight={["4px", "5px", "8px", "8px"]}
                  marginTop={["4px", "5px", "8px", "8px"]}
                  marginBottom={["4px", "5px", "8px", "8px"]}
                  backgroundColor={"white"}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  height={["90px", "100px", "120px", "150px"]}
                >
                  <Block
                    as={"img"}
                    height={["70%", "70%", "80%", "80%"]}
                    src={channel.coverImg}
                    alt={channel.name}
                  />
                </Block>
              </Block>
            ))}
          </Block>
        </div>
      ))}
    </Slider>
  )
}

export default HighlightChannelList
